import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/dashboard/activity/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/activity/$canvasId',
      params: { canvasId: 'activity_cards' },
    });
  },
});
